import $ from 'jquery';

const elements = {
  $filter: $('#filter'),
};

function init() {
  if (window.location.hash === '#filter') {
    $('html, body').animate({
      scrollTop: elements.$filter.offset().top,
    });
  }
}
export default init;



// WEBPACK FOOTER //
// ./src/components/components/default/blog-listing/mando-ui.blog-listing.js